module.exports = __webpack_public_path__ + "img/HQ-OA-360V03NGU.335918fe.jpg";